import {
  createApiClients,
  createCognitoAuth,
  createMockApiClients,
  createMockAuth,
  createMockWorld,
  type ApiClients,
  type ApiSession,
  type AppConfig,
  type AppPrincipal,
  type AuthAdapter,
} from '@platform/app-kit';

/** Everything the console needs that depends on the auth mode, built once from the configuration. */
export interface Runtime {
  config: AppConfig;
  adapter: AuthAdapter;
  createApi: (session: ApiSession & { getPrincipal: () => AppPrincipal | null }) => ApiClients;
}

/**
 * The console signs in against the control plane's platform-admin pool (`audience: platform`,
 * TOTP required by the pool) and talks to `/api/platform` and `/api/billing`, which the cell
 * edge proxies to the control plane.
 */
export function createRuntime(config: AppConfig): Runtime {
  if (config.auth.mode === 'mock') {
    const world = createMockWorld();
    return {
      config,
      adapter: createMockAuth({ world, audience: 'platform', appName: config.appName }),
      createApi: (session) => createMockApiClients({ world, getPrincipal: session.getPrincipal }),
    };
  }
  const auth = config.auth;
  return {
    config,
    adapter: createCognitoAuth({ config: auth, audience: 'platform', appName: config.appName }),
    createApi: (session) => createApiClients({ config, session }),
  };
}
